<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th jhiSortBy="name">
          <span jhiTranslate="transporterMember.service">First Name</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="isApplicableAsSales">
          <span jhiTranslate="transporterMember.commercialTeam">isApplicableAsSales</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let transporterGroup of transporterGroups; trackBy: trackId">
        <td>
          <span class="no-capitalize">{{ transporterGroup.name }}</span>
        </td>
        <td>
          <span class="no-capitalize">{{ transporterGroup.isApplicableAsSales! | transformBooleanToYesOrNo }}</span>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <a
              [routerLink]="PATHS.MIDDLE_COMMERCIAL_SERVICE_ID_EDIT.withId(transporterGroup.id)"
              [mdbTooltip]="'entity.action.edit' | translate"
              mdbBtn
              [floating]="true"
              [outline]="true"
              size="sm"
              color="primary"
            >
              <mdb-icon fas icon="pencil-alt"></mdb-icon>
            </a>
            <a (click)="delete(transporterGroup)" [mdbTooltip]="'entity.action.delete' | translate" mdbBtn [floating]="true" size="sm" color="primary">
              <mdb-icon fas icon="times"></mdb-icon>
            </a>
          </div>
        </td>
      </tr>
      <tr [hidden]="transporterGroups && transporterGroups.length > 0" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="transporterGroup.noData">No services</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
